<template>
  <el-select
    style="width: 300px; margin-left: 20px"
    v-model="localValue"
    size="size"
    multiple="multiple"
    placeholder="Статус"
    @change="selected"
    filterable
  >
    <el-option
      key="pending"
      label="Не оценено"
      value="pending"
    />
    <el-option
      v-if="!disabled_manage_request"
      key="manage_request"
      label="На согласовании у руководителя"
      value="manage_request"
    />
    <el-option
      key="evaluated"
      label="Оценено"
      value="evaluated"
    />
  </el-select>
</template>

<script>
export default {
  name: "eval-evaluator-status-select",
  props: {
    value: '',
    disabled_manage_request: false,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style>

</style>
